'use strict';

// Modernizr
require('./modernizr');

// Components
require('./components/hero_slide');
require('./components/nav_popup');
require('./components/load_more');
require('./components/coffee_popup');
require('./components/filter_search');
require('./components/sort_categories');
require('./components/newsletter');
require('./components/services');




// WEBPACK FOOTER //
// ./main.js